import React, { useState } from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';
import TypeWriter from 'typewriter-effect';
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation } from "swiper";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";

const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

const Roadmap = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {
  const outerClasses = classNames(
    'section',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'section-inner roadmap-section'
  );
    /*
  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );
  */

  const sectionHeader = {
    title: 'Our Games'
  };

  const [speechBubbleText, setSpeechBubbleText] = useState();

  const milestone0Text = "Play games, win tokens, exchange for prizes. What could be better? Maybe a Tesla or Bored Ape? Don’t worry, we got you covered.";
  const milestone1Text = "The rarer your NFT, the higher value games you can access for larger prizes. No rare NFT's? Fuse your lower level NFT’s into higher level ones!";
  const milestone2Text = "Join us as we donate 100% of our mint profits to building schools physically and virtually all around the world.";
  const milestone3Text = "Gain a mystery NFT on mint that reveals one of 5 NFT rarities with over 700 layers in gender, careers, species, attributes, and more!";
  const milestone4Text = "If you have any more questions, check our FAQ section down below or join our discord!";

  const Slide = ({ imgSource, title, description }) => {
    return (
      <div className='roadmap-slide-container'>
        <div className='roadmap-slide-img-container'>
          <Image src={imgSource} />
        </div>
        <div className='roadmap-slide-text-content'>
          <div className='roadmap-slide-title'>{title}</div>
          <div className='roadmap-slide-description'>{description}</div>
        </div>
      </div>
    );
  }

  const MobileRoadMap = () => {
    return (
      <Swiper
        speed={500}
        effect={"coverflow"}
        loop={true}
        // loopPreventsSlide={false}
        preventClicks={false}
        slidesPerView={"auto"}
        grabCursor={true}
        navigation={true}
        centeredSlides={true}
        slideToClickedSlide={true}
        coverflowEffect={{
          rotate: 20,
          stretch: 0,
          depth: 100,
          modifier: 0.8,
          slideShadows: false,
        }}
        pagination={false}
        threshold={2}
        resistanceRatio={0.5}
        modules={[EffectCoverflow, Navigation]}
        className="roadmap-mobile-swiper"
      >
        <SwiperSlide>
          <Slide
            imgSource={require('./../../assets/images/roadmap/Tree.png')}
            title="Win Awesome Prizes"
            description={milestone0Text}
          />
        </SwiperSlide>
        <SwiperSlide>
          <Slide
            imgSource={require('./../../assets/images/roadmap/Tree_2.png')}
            title="Upgrade your NFTs"
            description={milestone1Text}
          />
        </SwiperSlide>
        <SwiperSlide>
          <Slide
            imgSource={require('./../../assets/images/roadmap/Tree_3.png')}
            title="Profits Go To Charity"
            description={milestone2Text}
          />
        </SwiperSlide>
        <SwiperSlide>
          <Slide
            imgSource={require('./../../assets/images/roadmap/Tree_5.png')}
            title="Highly Detailed NFTs"
            description={milestone3Text}
          />
        </SwiperSlide>
        <SwiperSlide>
          <Slide
            imgSource={require('./../../assets/images/roadmap/Tree_4.png')}
            title="Still Have Questions?"
            description={milestone4Text}
          />
        </SwiperSlide>
        
      </Swiper>
    );
  }


  return (
    <section
      {...props}
      className={outerClasses}
    >
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content reveal-from-bottom" data-reveal-delay="100" />
          <h2 className='roadmap-img-text'>
            Enter the EduVerse: a universe with endless possibilities and chock full of adventure!
          </h2>
          <MobileRoadMap/>
          <div className={"roadmap-img-container"}>
            <div className={"roadmap-img-wrapper"}>
              <h2 className='roadmap-img-text'>
                Win Awesome Prizes
              </h2>
              <Image
                id={"tree1"}
                className={"roadmap-img"}
                src={require('./../../assets/images/roadmap/Tree.png')}
                onMouseEnter={() => {
                  setSpeechBubbleText(`${milestone0Text}`);
                  document.getElementById("roadmap-speech-bubble-text").style.top = "150px";
                }}
              />
            </div>

            <div className="roadmap-img-wrapper">
              <Image
                id={"tree2"}
                className={"roadmap-img"}
                src={require('./../../assets/images/roadmap/Tree_2.png')}
                onMouseEnter={() => {
                  setSpeechBubbleText(`${milestone1Text}`);
                  document.getElementById("roadmap-speech-bubble-text").style.top = "130px";
                }}
              />
              <h2 className='roadmap-img-text'>
                Upgrade Your NFTs
              </h2>
            </div>

            <div className="roadmap-img-wrapper">
              <h2 className='roadmap-img-text'>
                Profits Go To Charity
              </h2>
              
              <Image
                id={"tree3"}
                className={"roadmap-img"}
                src={require('./../../assets/images/roadmap/Tree_3.png')}
                onMouseEnter={() => {
                  setSpeechBubbleText(`${milestone2Text}`);
                  document.getElementById("roadmap-speech-bubble-text").style.top = "140px";
                }}
              />
            </div>

            <div className="roadmap-img-wrapper">
              <Image
              id={"tree4"}
              className={"roadmap-img"}
              src={require('./../../assets/images/roadmap/Tree_5.png')}
              onMouseEnter={() => {
                setSpeechBubbleText(`${milestone3Text}`);
                document.getElementById("roadmap-speech-bubble-text").style.top = "135px";
              }}
              />
              <h2 className='roadmap-img-text'>
                Highly Detailed NFTs
              </h2>
            </div>

            <div className="roadmap-img-wrapper">
              <h2 className='roadmap-img-text'>
                Got More Questions?
              </h2>
              
              <Image
              id={"tree5"}
              className={"roadmap-img"}
              src={require('./../../assets/images/roadmap/Tree_4.png')}
              onMouseEnter={() => {
                setSpeechBubbleText(`${milestone4Text}`);
                document.getElementById("roadmap-speech-bubble-text").style.top = "160px";
              }}/>
            </div>
          </div>

          <div className={'roadmap-kid'}>
            <Image
              className={"roadmap-kid-img"}
              src={require('./../../assets/images/Developer1.png')}
            />

            <div 
              id={"roadmap-speech-bubble-container"} 
              className={speechBubbleText !== "" ? "show" : "show-none"}
            >
              <div className={"roadmap-speech-bubble-text"}>
                <TypeWriter
                  options={{
                    delay: 2,
                    strings: [speechBubbleText],
                    autoStart: speechBubbleText !== "",
                    loop: false,
                    pauseFor: 30000,
                    deleteSpeed: 5
                  }}
                />
              </div>
            </div>
          </div>
        </div>
    </section>
  );
}

Roadmap.propTypes = propTypes;
Roadmap.defaultProps = defaultProps;

export default Roadmap;